import type { ComponentType } from 'react';

interface KPICardProps {
  label: string;
  value: string;
  icon: ComponentType<{ className?: string }>;
  /** Tailwind palette name, e.g. "blue", "green", "purple", "red". */
  palette?: 'blue' | 'green' | 'purple' | 'red';
}

const PALETTES: Record<NonNullable<KPICardProps['palette']>, { card: string; iconBg: string }> = {
  blue: { card: 'from-blue-50 to-blue-100', iconBg: 'bg-blue-500' },
  green: { card: 'from-green-50 to-green-100', iconBg: 'bg-green-500' },
  purple: { card: 'from-purple-50 to-purple-100', iconBg: 'bg-purple-500' },
  red: { card: 'from-red-50 to-red-100', iconBg: 'bg-red-500' },
};

export function KPICard({ label, value, icon: Icon, palette = 'blue' }: KPICardProps) {
  const p = PALETTES[palette];
  return (
    <div className={`card bg-gradient-to-br ${p.card}`}>
      <div className="card-body">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-gray-600">{label}</p>
            <p className="text-2xl font-bold text-gray-900">{value}</p>
          </div>
          <div className={`p-3 ${p.iconBg} rounded-full`}>
            <Icon className="h-6 w-6 text-white" />
          </div>
        </div>
      </div>
    </div>
  );
}
